import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core'
import {
  getPreElegibilityAnswerByProject,
  getProductionAndLossByForm,
  getSectorList,
} from '../../../../../services/Elegibilidad/get'
import { insertProductionandLoss } from '../../../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import NumberFormat from 'react-number-format'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'

export const Modal33 = ({
  openSec33,
  setOpenSec33,
  getDataTableProductionAndLoss,
  data,
}) => {
  const { idElegibilityForm, EligibilityForm } = useFormElegibilidad()

  const [sectorList, setSectorList] = useState([])
  const [loading, setLoading] = useState(false)
  const [errorArea, setErrorArea] = useState(false)

  let sumTable = 0
  let sumHectares = 0

  const GeneralDataSchema = Yup.object().shape({
    area: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(50, 'Máximo 50 caracteres'),
    idCategory: Yup.number()
      .required('Este campo es obligatorio')
      .max(8, '8 digitos'),
    hectares: Yup.number().required('Este campo obligatorio'),
    subProjectHectares: Yup.number()
      .required('Este campo es obligatorio')
      .test(
        'superior',
        'Cantidad de hectáreas que formarán parte del subproyecto no debe ser mayor a la cantidad ingresada en Hectáreas ',
        function (f) {
          const ref = Yup.ref('hectares')
          return f <= this.resolve(ref)
        },
      )
      .when('validateHectares', {
        is: true,
        then: Yup.number().test(
          'superior',
          'No debe de ser mayor a la hectáreas del subproyecto',
          function (f) {
            const ref = Yup.ref('HectaresForValidate')
            return f <= this.resolve(ref)
          },
        ),
      }),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      area: '',
      idCategory: '',
      hectares: '',
      subProjectHectares: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleGuardar()
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const getListSector = async () => {
    try {
      const response = await getSectorList()
      setSectorList(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const getInfoProject = async () => {
    try {
      const response = await getPreElegibilityAnswerByProject(
        EligibilityForm.IdProject,
      )

      if (response.Success) {
        if (response.Data[0].IdSector !== 8)
          formik.setFieldValue('idCategory', response.Data[0].IdSector)
        else {
          formik.setFieldValue('idCategory', response.Data[0].IdSector)
          formik.setFieldValue(
            'CategoryDesc',
            response.Data[0].DescriptionSector,
          )
        }
      }
      if (response.Data[0].IsHa !== '') {
        formik.setFieldValue('validateHectares', true)
        formik.setFieldValue(
          'HectaresForValidate',
          Number(response.Data[0].Answer),
        )

        sumHectares = response.Data[0].Answer
      }
    } catch (error) {
      console.log(error)
    }
  }

  // funcion para obtener la data de la tabla 3.3
  const getDataTableProductionAndLossModal = async () => {
    try {
      const response = await getProductionAndLossByForm(idElegibilityForm)
      if (response.Success) {
        if (response.Data !== [])
          response.Data.reduce((accumulator, object) => {
            sumTable = accumulator + object.SubProjectHectares
            return accumulator + object.SubProjectHectares
          }, 0)

        const rest = Number(sumHectares) - Number(sumTable)
        formik.setFieldValue('HectaresForValidate', rest)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (openSec33 === true) {
      getListSector()
      getInfoProject()
      getDataTableProductionAndLossModal()
    }
  }, [openSec33])

  const handleGuardar = async () => {
    setLoading(true)
    const body = {
      IdProductionAndLosseByClimate: 0,
      IdElegibilityAnswer: idElegibilityForm,
      Area: formik.values.area,
      IdCategory: formik.values.idCategory,
      Hectares: formik.values.hectares,
      SubProjectHectares: formik.values.subProjectHectares,
      CategoryDesc: '',
      RecentClimaticEvent: '',
      AnnualAverageYieldUnit: '',
      AnnualAverageYield: 0,
      AnnualEstimatedLossUnit: '',
      AnnualEstimatedLoss: 0,
    }

    const response = await insertProductionandLoss(body)
    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getDataTableProductionAndLoss()
      handleClose()
    }
  }

  const handleClose = () => {
    setOpenSec33(false)
    setErrorArea(false)
    setLoading(false)
    formik.resetForm()
    sumTable = 0
    sumHectares = 0
  }
  return (
    <>
      <Modal
        open={openSec33}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">
              Datos de la producción y hectáreas afectadas
            </h1>
          </div>

          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Rubro / Producto</label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, numeral, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Rubro / Producto"
                    customInput={TextField}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-()#,.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorArea(false)
                        formik.setFieldValue('area', e.target.value)
                      } else {
                        setErrorArea(true)
                      }
                    }}
                    value={formik.values.area}
                    maxLength={50}
                  ></textarea>
                  {errorArea ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.area ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.area}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Categoría</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  {formik.values.idCategory !== '' &&
                  formik.values.idCategory !== 8 ? (
                    <Select
                      id="IdProject"
                      name="IdProject"
                      variant="outlined"
                      value={formik.values.idCategory}
                      error={formik.errors.idCategory}
                      displayEmpty={true}
                      onChange={(e) => {
                        formik.setFieldValue('idCategory', e.target.value)
                      }}
                      disabled
                    >
                      <MenuItem disabled value="">
                        Seleccione una opción
                      </MenuItem>
                      {sectorList &&
                        sectorList.map((item, key) => (
                          <MenuItem key={key} value={item.IdSector}>
                            {item.Description}
                          </MenuItem>
                        ))}
                    </Select>
                  ) : (
                    <FormControl fullWidth>
                      <TextField
                        id="MiPymeCountry"
                        name="MiPymeCountry"
                        type="text"
                        variant="outlined"
                        sx={{ width: 220 }}
                        value={formik.values.CategoryDesc}
                        disabled
                      />
                    </FormControl>
                  )}
                  {formik.errors.idCategory ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.idCategory}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Cantidad de hectáreas que posee la MIPYME
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareas"
                          allowLeadingZeros={false}
                          name="cantHectareas"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.hectares}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'hectares',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          inputProps={{ maxLength: 10 }}
                          decimalScale={2}
                          error={formik.errors.hectares}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Cantidad de hectáreas que formarán parte del subproyecto
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareasSubproyecto"
                          name="cantHectareasSubproyecto"
                          allowLeadingZeros={false}
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.subProjectHectares}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'subProjectHectares',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          inputProps={{ maxLength: 10 }}
                          decimalScale={2}
                          error={formik.errors.subProjectHectares}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12} sm={6} md={6}>
                  {formik.errors.hectares ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.hectares}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  {formik.errors.subProjectHectares ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.subProjectHectares}
                    </div>
                  ) : null}
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                  disabled={loading}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
